// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/benchmarkconsts.proto (package aurora.core.consts.benchmark, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/benchmarkconsts.proto.
 */
export const file_consts_benchmarkconsts: GenFile = /*@__PURE__*/
  fileDesc("Chxjb25zdHMvYmVuY2htYXJrY29uc3RzLnByb3RvEhxhdXJvcmEuY29yZS5jb25zdHMuYmVuY2htYXJrKlgKCUJlbmNobWFyaxIPCgtVTlNQRUNJRklFRBAAEggKBE9CRlIQARIICgRFRkZSEAISCAoEU09GUhADEggKBEJHQ1IQBBIICgRUR0NSEAUSCAoESU9SQhAGQilaJ2dpdGxhYi5wcnZibC5jb20vYXVyb3JhL2NvcmUvc3JjL2NvbnN0c2IGcHJvdG8z");

/**
 * possible rate benchmarks
 *
 * @generated from enum aurora.core.consts.benchmark.Benchmark
 */
export enum Benchmark {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OBFR = 1;
   */
  OBFR = 1,

  /**
   * @generated from enum value: EFFR = 2;
   */
  EFFR = 2,

  /**
   * @generated from enum value: SOFR = 3;
   */
  SOFR = 3,

  /**
   * @generated from enum value: BGCR = 4;
   */
  BGCR = 4,

  /**
   * @generated from enum value: TGCR = 5;
   */
  TGCR = 5,

  /**
   * @generated from enum value: IORB = 6;
   */
  IORB = 6,
}

/**
 * Describes the enum aurora.core.consts.benchmark.Benchmark.
 */
export const BenchmarkSchema: GenEnum<Benchmark> = /*@__PURE__*/
  enumDesc(file_consts_benchmarkconsts, 0);

